import type { IMessage } from '@/lib/types/chat';

type ContextUsage = Pick<
  IMessage,
  'contextUsedTokens' | 'contextMaxTokens' | 'contextPercent' | 'contextSoftLimitTokens'
>;

const numberOrNull = (value: unknown): number | null => (typeof value === 'number' ? value : null);

/**
 * Context-window usage of a listed message, computed backend-side (camelCase
 * top-level fields): the numbers the answer info and the context gauge in the
 * composer read (KAN-1576).
 */
export const contextUsageOf = (message: {
  contextUsedTokens?: unknown;
  contextMaxTokens?: unknown;
  contextPercent?: unknown;
  contextSoftLimitTokens?: unknown;
}): ContextUsage => ({
  contextUsedTokens: numberOrNull(message.contextUsedTokens),
  contextMaxTokens: numberOrNull(message.contextMaxTokens),
  contextPercent: numberOrNull(message.contextPercent),
  contextSoftLimitTokens: numberOrNull(message.contextSoftLimitTokens),
});
